import type {} from '@mui/x-date-pickers/themeAugmentation';
import { alpha, Theme } from '@mui/material/styles';

// MUI X v8 DatePicker ใช้ PickersTextField / PickersOutlinedInput ไม่ใช่ TextField + OutlinedInput
// ค่า default ของ sectionsContainer เป็น padding แนวตั้ง 16.5px — สูงกว่า MuiOutlinedInput (10.5px)
// อ้างอิงเดียวกับ themes/overrides/OutlinedInput.ts

export default function PickersTextField(theme: Theme) {
  const radius = typeof theme.shape.borderRadius === 'number' ? Math.max(theme.shape.borderRadius, 8) : 8;

  return {
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: radius,
          transition: theme.transitions.create(['box-shadow', 'border-color', 'background-color'], {
            duration: theme.transitions.duration.shorter
          }),
          '&:hover:not(.Mui-disabled):not(.Mui-error)': {
            backgroundColor: alpha(theme.palette.action.hover, theme.palette.mode === 'dark' ? 0.12 : 0.04)
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.grey[200], 0.12) : '#f5f5f5',
            '& .MuiPickersOutlinedInput-notchedOutline': {
              borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[200] : '#e8e8e8'
            },
            '& .MuiPickersOutlinedInput-input': {
              WebkitTextFillColor: theme.palette.text.primary
            }
          },
          '& .MuiInputAdornment-root': {
            marginRight: 2
          },
          '& .MuiInputAdornment-root .MuiIconButton-root': {
            padding: 4,
            width: 32,
            height: 32
          },
          // size small: คงค่า default ของ MUI X (8.5px แนวตั้ง)
          '&.MuiPickersInputBase-inputSizeSmall .MuiPickersOutlinedInput-sectionsContainer': {
            padding: '8.5px 0'
          }
        },
        sectionsContainer: {
          padding: '10.5px 0'
        }
      }
    }
  };
}
